import { render, staticRenderFns } from "./CustomerReceivables3.vue?vue&type=template&id=35f0bd26&scoped=true&"
import script from "./CustomerReceivables3.vue?vue&type=script&lang=js&"
export * from "./CustomerReceivables3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f0bd26",
  null
  
)

export default component.exports